import {
    wantedConstants
} from '../_constants';
import {
    wantedService
} from '../_services';
import {
    alertActions
} from './';
import {
    history
} from '../_helpers';
import { pushNotificationService } from '../_services/pushNotification';

export const wantedAction = {
    createWantedType,
    getAllWantedType,
    getWantedType,
    updateWantedType,
    getWantedTypeViewsById,
    getWanted,
    createMobile,
    createVehicle,
    createLicenseNumber
}

function createWantedType(data) {
    return dispatch => {
        dispatch(request());
        wantedService.createWantedType(data)
            .then((response) => {
                dispatch(success(response));
            }, error => {
                dispatch(failure(error));
            })
    }

    function request(wantedtype) {
        return {
            type: wantedConstants.SAVE_WANTEDTYPE_REQUEST,
            wantedtype
        }
    }

    function success(wantedtype) {
        return {
            type: wantedConstants.SAVE_WANTEDTYPE_SUCCESS,
            wantedtype
        }
    }

    function failure(error) {
        return {
            type: wantedConstants.SAVE_WANTEDTYPE_FAILURE,
            error
        }
    }
}

function createLicenseNumber(data) {
    return dispatch => {
        dispatch(request());
        wantedService.createLicenseNumber(data)
            .then((response) => {
                dispatch(success(response));
            }, error => {
                dispatch(failure(error));
            })
    }

    function request(createLicense) {
        return {
            type: wantedConstants.SAVE_LICENSE_REQUEST,
            createLicense
        }
    }

    function success(createLicense) {
        return {
            type: wantedConstants.SAVE_LICENSE_SUCCESS,
            createLicense
        }
    }

    function failure(error) {
        return {
            type: wantedConstants.SAVE_LICENSE_FAILURE,
            error
        }
    }
}

function createVehicle(data) {
    return dispatch => {
        dispatch(request());
        wantedService.createVehicle(data)
            .then((response) => {
                dispatch(success(response));
            }, error => {
                dispatch(failure(error));
            })
    }

    function request(createVehicle) {
        return {
            type: wantedConstants.SAVE_VEHICLE_REQUEST,
            createVehicle
        }
    }

    function success(createVehicle) {
        return {
            type: wantedConstants.SAVE_VEHICLE_SUCCESS,
            createVehicle
        }
    }

    function failure(error) {
        return {
            type: wantedConstants.SAVE_VEHICLE_FAILURE,
            error
        }
    }
}

function createMobile(data) {
    return dispatch => {
        dispatch(request());
        wantedService.createMobile(data)
            .then((response) => {
                dispatch(success(response));
            }, error => {
                dispatch(failure(error));
            })
    }

    function request(createMobile) {
        return {
            type: wantedConstants.SAVE_MOBILE_REQUEST,
            createMobile
        }
    }

    function success(createVehicle) {
        return {
            type: wantedConstants.SAVE_MOBILE_SUCCESS,
            createMobile
        }
    }

    function failure(error) {
        return {
            type: wantedConstants.SAVE_MOBILE_FAILURE,
            error
        }
    }
}


function getWantedType(itemType, role, cityId) {
    return dispatch => {
        dispatch(request());
        wantedService.getWantedType(itemType, role, cityId)
            .then((response) => {
                dispatch(success(response));
            }, error => {
                dispatch(failure(error));
            })
    }

    function request(wantedType) {
        return {
            type: wantedConstants.GET_WANTEDTYPE_REQUEST,
            wantedType
        }
    }

    function success(wantedType) {
        return {
            type: wantedConstants.GET_WANTEDTYPE_SUCCESS,
            wantedType
        }
    }

    function failure(error) {
        return {
            type: wantedConstants.GET_WANTEDTYPE_FAILURE,
            error
        }
    }
}
function getAllWantedType(itemType, userid) {
    return dispatch => {
        dispatch(request());
        wantedService.getAllWantedType(itemType, userid)
            .then((response) => {
                dispatch(success(response));
            }, error => {
                dispatch(failure(error));
            })
    }

    function request(wantedType) {
        return {
            type: wantedConstants.GET_WANTEDTYPE_REQUEST,
            wantedType
        }
    }

    function success(wantedType) {
        return {
            type: wantedConstants.GET_WANTEDTYPE_SUCCESS,
            wantedType
        }
    }

    function failure(error) {
        return {
            type: wantedConstants.GET_WANTEDTYPE_FAILURE,
            error
        }
    }
}

function updateWantedType(id, data) {
    let reqObj = {
        ...data,
        id
    }

    return dispatch => {
        dispatch(request());
        wantedService.updateWantedType(id, data)
            .then((response) => {
                dispatch(success(reqObj));
            }, error => {
                dispatch(failure(error));
            })
    }

    function request(wantedType) {
        return {
            type: wantedConstants.UPDATE_WANTEDTYPE_REQUEST,
            wantedType
        }
    }

    function success(wantedType) {
        return {
            type: wantedConstants.UPDATE_WANTEDTYPE_SUCCESS,
            wantedType
        }
    }

    function failure(error) {
        return {
            type: wantedConstants.UPDATE_WANTEDTYPE_FAILURE,
            error
        }
    }
}
/**
 * 
 * @param {*} id 
 * get Wanted type by ID
 * @returns 
 */
function getWantedTypeViewsById(id) {
    return dispatch => {
        dispatch(request());
        wantedService.getWantedTypeViewsById(id)
            .then((response) => {
                dispatch(success(response));
            }, error => {
                dispatch(failure(error));
            })


        function request(wantedViewList) {
            return {
                type: wantedConstants.GET_WANTED_BY_ID_REQUEST,
                wantedViewList
            }
        }

        function success(wantedViewList) {
            return {
                type: wantedConstants.GET_WANTED_BY_ID_SUCCESS,
                wantedViewList
            }
        }

        function failure(error) {
            return {
                type: wantedConstants.GET_WANTED_BY_ID_FAILURE,
                error
            }
        }
    }
}

function getWanted() {

    return dispatch => {
        dispatch(request());
        wantedService.getWanted()
            .then((response) => {
                dispatch(success(response));
            }, error => {
                dispatch(failure(error));
            })
    }

    function request(getWanted) {
        return {
            type: wantedConstants.GET_WANTED_REQUEST,
            getWanted
        }
    }

    function success(getWanted) {
        return {
            type: wantedConstants.GET_WANTED_SUCCESS,
            getWanted
        }
    }

    function failure(error) {
        return {
            type: wantedConstants.GET_WANTED_FAILURE,
            error
        }
    }
}






